import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import {
  ErrorDetails,
  CarrierRegistrationRequestDto,
  CarrierSolicitudeResponseDto,
  ContractorRegistrationRequestDto, LocalCompanyRegistrationRequestDto
} from '../../authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';
import { IGetAccountSolicitudeCommandParameters } from './getAccountSolicitude.command';

export class CreateLocalCompanyCommand extends IRequestCommand<
  ICommandResponse,
  ErrorDetails,
  CreateLocalCompanyCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.PUT;
  override _commandUrl = 'carrier/{carrierId}/addCompany ';
  override setParameters(parameters: CreateLocalCompanyCommandParameters) {
    if(parameters.editMode){
      this._commandType = CommandRequestType.POST;
      this._commandUrl = 'carrier/{carrierId}/updateCompany ';
    }
    this._commandUrl = this._commandUrl.replace(
      '{carrierId}',
      parameters.carrierId.toString()
    );
    this._commandBody = parameters;
  }
}

export interface CreateLocalCompanyCommandParameters
  extends LocalCompanyRegistrationRequestDto,
    ICommandParameters {
    carrierId?: number | string;
    editMode:boolean;
    mainUserFirstName?: string;
    mainUserLastName?: string;
    paymentTerm?: number;
    billingEmail?: string;
    billingPhone?: string;
    portalEnabled?: boolean;
}
